import React from 'react';
import { RotateCcwIcon, TagIcon } from 'lucide-react';
import { formatRwf } from '../../../utils/currency';
export function ReturnsScreen() {
  return <div className="w-full max-w-[380px] space-y-3" data-id="element-1355" data-mp="25istjt1no7z5">
      <div className="rounded-[14px] bg-white p-5 shadow-[0_18px_40px_-24px_rgba(11,11,11,0.28)]" data-id="element-1356" data-mp="29m8kq9uyhg4g">
        <div className="flex items-center gap-2" data-id="element-1357" data-mp="2edh0dnmvpxq2">
          <span className="flex h-7 w-7 items-center justify-center rounded-[8px] bg-brand-soft text-brand" data-id="element-1358" data-mp="2ef1s75ht72k8">
            <TagIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1359" data-mp="2obejxxtsn6cc" />
          </span>
          <p className="text-[14px] font-semibold text-ink" data-id="element-1360" data-mp="2odhix7cxc9t7">Weekend promotion</p>
          <span className="ml-auto rounded-full bg-[#E9F6EC] px-2 py-0.5 text-[11px] font-medium text-[#1B7A3D]" data-id="element-1361" data-mp="2taziw88yrep2">
            Active
          </span>
        </div>
        <div className="mt-3 flex items-center justify-between text-[13px]" data-id="element-1362" data-mp="yx8djkxo3gzf">
          <span className="text-ink-muted" data-id="element-1363" data-mp="12y1xy4bwidnk">10% off all bakery items</span>
          <span className="font-medium text-ink" data-id="element-1364" data-mp="1304qow4fukvz">Sat–Sun</span>
        </div>
      </div>

      <div className="rounded-[14px] bg-white p-5 shadow-[0_18px_40px_-24px_rgba(11,11,11,0.28)]" data-id="element-1365" data-mp="2n1zwbq52n3r7">
        <div className="flex items-center justify-between" data-id="element-1366" data-mp="2i8nmwn8yr3j1">
          <p className="flex items-center gap-2 text-[14px] font-semibold text-ink" data-id="element-1367" data-mp="2da2mampsuhu2">
            <RotateCcwIcon className="h-4 w-4 text-ink-muted" aria-hidden="true" data-id="element-1368" data-mp="28casto9iannr" />
            Return · Receipt 00471/NS
          </p>
        </div>
        <div className="mt-3 flex items-center justify-between border-t border-canvas-line pt-3 text-[13px]" data-id="element-1369" data-mp="35yroyq6i6v7x">
          <span className="text-ink-soft" data-id="element-1370" data-mp="30yde70dip767">1 × Electric kettle 1.7L</span>
          <span className="font-medium text-ink" data-id="element-1371" data-mp="2w022sl7kqolv">{formatRwf(18500)}</span>
        </div>
        <div className="mt-2 flex items-center justify-between text-[12px] text-ink-muted" data-id="element-1372" data-mp="2r18rmzfrf9ov">
          <span data-id="element-1373" data-mp="1kmget3dgat1x">Refund to</span>
          <span data-id="element-1374" data-mp="1knhslfluptnc">Mobile money · 078 •••• 390</span>
        </div>
        <div className="mt-2 flex items-center justify-between text-[12px] text-ink-muted" data-id="element-1375" data-mp="1fmu1yv1jbetn">
          <span data-id="element-1376" data-mp="7nemcz63cqs1">Stock</span>
          <span data-id="element-1377" data-mp="7ozdsfx3ztlo">Returned to shelf (+1)</span>
        </div>
        <div className="mt-4 flex gap-2" data-id="element-1378" data-mp="bozxog2z8x04">
          <span className="flex-1 rounded-[8px] border border-canvas-line py-2.5 text-center text-[12px] font-medium text-ink" data-id="element-1379" data-mp="boq3sheta5p5">
            Cancel
          </span>
          <span className="flex-1 rounded-[8px] bg-brand py-2.5 text-center text-[12px] font-semibold text-white" data-id="element-1380" data-mp="2o1xy9zknbnc">
            Refund {formatRwf(18500)}
          </span>
        </div>
      </div>
    </div>;
}